<template>
  <div
    id="topbar"
    style="background: white;
  bottom: 40px; width: 40px; border-radius: 4px; height: 180px;"
    class="elevation-2"
  >
    <v-tooltip :open-delay="500" right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          title="Tegn polygon"
          aria-label="Tegn polygon"
          text
          class="zoom-button"
          v-bind="attrs"
          v-on="on"
          @click="drawPolygon()"
        >
          <v-icon>mdi-vector-polygon</v-icon>
        </v-btn>
      </template>
      <span>Avgrens utvalg ved å tegne inn et område i kartet</span>
    </v-tooltip>

    <v-tooltip :open-delay="500" right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          title="Last opp shape fil"
          aria-label="Last opp shape fil"
          class="zoom-button"
          text
          v-bind="attrs"
          v-on="on"
          @click="shapeUploadDialog = true"
        >
          <v-icon size="20">mdi-file-upload-outline</v-icon>
        </v-btn>
      </template>
      <span>Avgrens utvalg med område fra shape fil</span>
    </v-tooltip>

    <v-tooltip :open-delay="500" right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          title="Rediger polygon"
          aria-label="Rediger polygon"
          class="zoom-button"
          text
          v-bind="attrs"
          v-on="on"
          :disabled="!polygonsAdded"
          @click="updateDrawing()"
        >
          <v-icon size="20">mdi-vector-polyline-edit</v-icon>
        </v-btn>
      </template>
      <span>Rediger innlagte områder</span>
    </v-tooltip>

    <v-tooltip :open-delay="500" right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          title="Klipp polygon"
          aria-label="Klipp polygon"
          class="zoom-button"
          text
          v-bind="attrs"
          v-on="on"
          :disabled="!polygonsAdded"
          @click="cutPolygon()"
        >
          <v-icon size="20">mdi-box-cutter</v-icon>
        </v-btn>
      </template>
      <span>Klipp bort del av områder</span>
    </v-tooltip>

    <v-tooltip :open-delay="500" right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          title="Fjern alle polygoner"
          aria-label="Fjern alle polygoner"
          class="zoom-button"
          text
          v-bind="attrs"
          v-on="on"
          :disabled="!polygonsAdded"
          @click="resetDrawing()"
        >
          <v-icon size="20">mdi-delete-outline</v-icon>
        </v-btn>
      </template>
      <span>Fjern alle områder</span>
    </v-tooltip>

    <input
      id="shapeUpload"
      ref="shapeFiles"
      aria-label="hidden importer fil"
      @change="processShapeFile($event)"
      type="file"
      hidden
    />

    <v-dialog v-model="shapeUploadDialog" width="500">
      <v-card>
        <v-card-title class="headline">Importer shapefil</v-card-title>
        <v-card-text class="text-body1">
          For å legge til områder fra shape må alle filene som hører til
          shape-filen være komprimert til en zip fil (i.e. .shp, .shx, .sbx,
          .sbn, cpg,.dbf og .prj samlet i en .zip)*. Alle polygoner i
          shape-filen vil bli lagt til i kartet. Eventuelle andre typer geometri
          i filen vil ikke bli lagt til. Klikk 'Velg fil' under for å åpne
          dialogboks for å velge zip fil.
        </v-card-text>
        <v-card-actions>
          <v-card-actions>
            <v-btn text @click="shapeUploadDialog = false">Avbryt</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="chooseFiles">Velg fil</v-btn>
          </v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-modal
      :active="removeAreasDialogActive"
      content="Ønsker du å fjerne innlagt polygon fra kartet?"
      title="Fjerne polygon"
      @confirm="removeAll"
      @cancel="removeAreasDialogActive = false"
    />
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import MapService from "../../../services/MapService";
import DialogModal from "../../Layout/DialogModal.vue";
import { mapActions, mapState } from "vuex";
export default {
  name: "MapDrawing",
  props: ["kartview", "tegnelag", "mainLayer"],
  data() {
    return {
      tegningAktiv: false,
      cuttingActive: false,
      modeAddGraphic: true,
      polygonsAdded: false,
      tempGraphicsLayer: null,
      sketchViewModel: null,
      removeAreasDialogActive: false,
      updateGraphic: null,
      shapeUploadDialog: false,
      polygonSymbol: {
        type: "simple-fill",
        color: [194, 194, 194, 0.2],
        style: "solid",
        outline: {
          color: "black",
          width: 3,
          style: "solid",
        },
      },
      polylineSymbol: {
        type: "simple-line",
        color: "#00a1ff",
        width: "2",
        style: "short-dot",
      },
    };
  },
  components: {
    DialogModal,
  },
  methods: {
    ...mapActions(["setShowPopups"]),
    drawPolygon: function() {
      this.tegningAktiv = true;
      this.modeAddGraphic = 1;
      this.startTegning();
    },
    updateDrawing: function() {
      if (this.sketchViewModel.state === "active") {
        this.sketchViewModel.complete();
      } else {
        this.setShowPopups(false);
        this.sketchViewModel.update(this.tempGraphicsLayer.graphics.items, {
          tool: "reshape",
          toggleToolOnClick: false,
        });
      }
    },
    cutPolygon: function() {
      this.cuttingActive = true;
      this.modeAddGraphic = 2;
      this.startTegning();
    },
    chooseFiles() {
      this.shapeUploadDialog = false;
      document.getElementById("shapeUpload").click();
    },
    processShapeFile() {
      this.modeAddGraphic = 1;
      let shapeFile = this.$refs.shapeFiles.files[0];
      this.getFeaturesFromZip(shapeFile, "shapeImport");
      this.$refs.shapeFiles.value = "";
    },
    removeAll() {
      this.sketchViewModel.cancel();
      this.tempGraphicsLayer.removeAll();
      this.polygonsAdded = false;
      this.tegningAktiv = false;
      this.$emit("tegning:oppdatert");
      this.removeAreasDialogActive = false;
    },
    getFeaturesFromZip: async function(zipFile, name) {
      loadModules(["esri/Graphic"]).then(async ([Graphic]) => {
        let mapService = new MapService();
        mapService
          .convertShapeToFeatureCollection(zipFile, name)
          .then(async (response) => {
            let layers = response.data.featureCollection.layers;

            for (let i = 0; i < layers.length; i++) {
              let layer = layers[i];
              if (layer.featureSet.geometryType == "esriGeometryPolygon") {
                let features = layer.featureSet.features;

                for (let j = 0; j < features.length; j++) {
                  let feature = features[j];
                  let geometry = feature.geometry;
                  geometry.type = "polygon";
                  let graphic = new Graphic({
                    geometry: geometry,
                    symbol: this.polygonSymbol,
                  });
                  await this.addGraphic({ graphic: graphic });
                }
              }
            }

            this.kartview.goTo(
              this.tempGraphicsLayer.graphics.items[0].geometry.extent.expand(
                1.75
              )
            );
          })
          .catch(function(error) {
            // eslint-disable-next-line no-console
            console.error(error);
          });
      });
    },
    resetDrawing: function() {
      this.sketchViewModel.cancel();
      this.tempGraphicsLayer.removeAll();
      this.polygonsAdded = false;
      this.tegningAktiv = false;
      this.$emit("tegning:oppdatert");
    },
    addGraphic: function async(evt) {
      loadModules(["esri/Graphic", "esri/geometry/geometryEngine"]).then(
        ([Graphic, geometryEngine]) => {
          var geometry = evt.graphic.geometry;
          var symbol;
          symbol = this.polygonSymbol;

          if (this.modeAddGraphic === 1 || this.modeAddGraphic === 3) {
            if (this.tempGraphicsLayer.graphics.length > 0) {
              let newGeometry = geometryEngine.union([
                geometry,
                this.tempGraphicsLayer.graphics.items[0].geometry,
              ]);
              let newGraphic = this.tempGraphicsLayer.graphics.items[0].clone();
              newGraphic.geometry = newGeometry;
              this.tempGraphicsLayer.removeAll();
              this.tempGraphicsLayer.add(newGraphic);
              this.polygonsAdded = true;
            } else {
              var graphic = new Graphic({
                geometry: geometry,
                symbol: symbol,
              });
              this.tempGraphicsLayer.add(graphic);
              this.polygonsAdded = true;
            }
          } else if (
            this.modeAddGraphic === 2 &&
            this.tempGraphicsLayer.graphics.length > 0
          ) {
            let existingGeometry = this.tempGraphicsLayer.graphics.items[0]
              .geometry;

            if (
              geometryEngine.overlaps(geometry, existingGeometry) ||
              geometryEngine.within(geometry, existingGeometry)
            ) {
              let newGeometry = geometryEngine.difference(
                existingGeometry,
                geometry
              );
              let newGraphic = this.tempGraphicsLayer.graphics.items[0].clone();
              newGraphic.geometry = newGeometry;
              this.tempGraphicsLayer.removeAll();
              this.polygonsAdded = true;
              this.tempGraphicsLayer.add(newGraphic);
            }
          }

          this.updateGraphic = null;
          this.tegningAktiv = false;
          this.cuttingActive = false;
          this.$emit("tegning:oppdatert");
        }
      );
    },
  },
  computed: {
    ...mapState([
      "useMapExtent",
      "activeGeographicFilterMode",
      "geographicFilterOptions",
    ]),
  },
  watch: {
    activeGeographicFilterMode: function(newVal, oldVal) {
      if (newVal !== oldVal && oldVal === this.geographicFilterOptions[2]) {
        if (this.tempGraphicsLayer.graphics.items.length > 0) {
          this.removeAreasDialogActive = true;
        }
      }
    },
  },
  mounted: function() {
    loadModules(["esri/widgets/Sketch/SketchViewModel"])
      .then(([SketchViewModel]) => {
        this.tempGraphicsLayer = this.tegnelag;

        this.sketchViewModel = new SketchViewModel({
          view: this.kartview,
          layer: this.tempGraphicsLayer,
          polygonSymbol: this.polygonSymbol,
          polylineSymbol: this.polylineSymbol,
          updateOnGraphicClick: false,
        });

        this.kartview.on("click", (evt) => {
          this.kartview.hitTest(evt).then((response) => {
            var results = response.results;
            if (
              results.length &&
              results[results.length - 1].graphic &&
              results[results.length - 1].graphic.layer.id == "tegnelag"
            ) {
              if (!this.updateGraphic) {
                this.updateGraphic = results[results.length - 1].graphic;
                this.tempGraphicsLayer.remove(this.updateGraphic);
                this.modeAddGraphic = 3;
                this.sketchViewModel.update(this.updateGraphic, {
                  tool: "move",
                  enableScaling: false,
                });
              }
            }
          });
        });

        this.sketchViewModel.on(
          "create",
          function(evt) {
            if (evt.state === "complete") {
              this.setShowPopups(true);
              this.addGraphic(evt);
            }
          }.bind(this)
        );
        this.sketchViewModel.on(
          "update",
          function(evt) {
            if (evt.state === "complete") {
              this.setShowPopups(true);
              this.addGraphic({ graphic: evt.graphics[0] });
            }
          }.bind(this)
        );

        this.startTegning = () => {
          this.sketchViewModel.create("polygon");
        };
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.error(err);
      });
  },
};
</script>
<style>
#topbar {
  position: absolute;
}

.action-button:hover,
.btn-map {
  height: 50px;
  color: rgb(75, 75, 75) !important;
  font-size: 8px !important;
  max-width: 65px;
  min-width: 65px;
  border-color: rgb(209, 209, 209) !important;
}

.btn-secondary:disabled {
  background: none !important;
}
</style>
